<!-- BOUTONS ACTIVER LE MODE MANU ET LE MODE AUTO -->
<div class="d-flex align-items-center mt-2 justify-content-sm-between">
  <div class="d-flex">
    <button (click)="changeMode('AUTO')" class="q-btn q-main mr-4 " >
      <i class="fas fa-tasks mr-2"></i>Sélectionner les tâches
    </button>
    <div class="checkbox checbox-switch switch-primary d-flex font-weight-bold" placement="bottom" ngbTooltip="Mode cursus">
      <span class="q-text-m mr-2">Cursus</span>
      <label>
        <input (change)="changeMode('CURSUS')" [(ngModel)]="IsModeCursus" type="checkbox" />
        <span></span>
      </label>
    </div>
  </div>
  <button title="administration" class="btn-no-background mr-4" (click)="changeMode('PARAM')">
    <i class="fa-solid fa-gears"></i>
  </button>
</div>
<!-- COMPOSANT ENFANT POUR LE MODE MANU ET LE MODE AUTO  -->
<queoval-stage-tache-tableau *ngIf="!IsModeCursus" [IdentStage]="service.Stage.Ident" [Mode]="tacheMode" [Init]="Init$"></queoval-stage-tache-tableau>

<queoval-stage-tache-param *ngIf="!IsModeCursus" [IdentStage]="service.Stage.Ident" [Mode]="tacheMode" [Init]="Init$" ></queoval-stage-tache-param>

<!-- COMPOSANT ENFANT POUR LE MODE CURSUS (BOUCLE SUR CHAQUE STAGE)-->
<ng-container *ngIf="IsModeCursus">
  <!-- INFOS DU CURSUS ET TOTAL -->
  <h4 class="font-weight-bold mt-2 q-c-main">{{InfosStageCursus.NomCursus}}</h4>
  <p class="font-weight-bold">Total temps: {{InfosStageCursus.TotalTempsCursus | number : '1.2-2' }}h</p>
  <p class="font-weight-bold">Total dépenses: {{InfosStageCursus.TotalDepensesCursus | number : '1.2-2' | money}}</p>
  <!-- INFOS STAGES ET COMPOSANT ENFANT -->
  <ng-container *ngIf="InfosStageCursus?.LstInfoStage && InfosStageCursus.LstInfoStage.length > 0 else templateNoData"></ng-container>
  <ng-container *ngFor="let stage of InfosStageCursus.LstInfoStage">
    <h5 class="font-weight-bold mt-5"><span class="q-c-main">{{stage.NumStage}} - </span> <span class="q-c-light-black">{{stage.NomStage}}</span></h5>
    <p><i class="far fa-calendar-alt mr-2 q-c-main"></i>Du {{stage.DateDebutStage}} au {{stage.DateLimiteStage}}</p>
    <queoval-stage-tache-tableau (lstIsEmpty)="verifyEmptyList($event,stage)" [IdentStage]="stage.IdentStage" [Mode]="tacheMode" [Init]="Init$"></queoval-stage-tache-tableau>
    <!-- SI LA LISTE DE TACHES DU COMPOSANT ENFANT EST VIDE -->
    <p *ngIf="stage.LstTacheIsEmpty" style="text-align: center; font-style: italic;">Pas de tâches rattachées au stage: <span class="q-c-main">{{stage.NomStage}}</span></p>
  </ng-container>
  <ng-template #templateNoData>
    <div class="mt-3">
      <div class="q-nodata q-c-light-main text-center">
        <p class="my-2"><i class="far fa-times-circle fa-2x"></i></p>
        Aucune donnée
      </div>
    </div>
  </ng-template>
</ng-container>

